import { createReducer } from "@reduxjs/toolkit";
import { resetLessonCancellation, teacherCancelLesson } from "./cancel-lesson";
import type { ProcessingState } from "@redux/state/shared-types";

const initialState: ProcessingState = { processing: "idle" };

export const teacherCancelLessonReducer = createReducer<ProcessingState>(initialState, builder => {
  builder
    .addCase(teacherCancelLesson.pending, state => {
      state.processing = "pending";
    })
    .addCase(teacherCancelLesson.fulfilled, state => {
      state.processing = "success";
    })
    .addCase(teacherCancelLesson.rejected, state => {
      state.processing = "failed";
    })
    .addCase(resetLessonCancellation, () => initialState);
});
